module.exports = __webpack_public_path__ + "img/quality.0864be4a.png";